import { createStackNavigator } from '@react-navigation/stack'
import React from 'react'
import {
  ExternalPhoto,
  GillPhoto,
  InternalPhoto,
  Necropsy,
  NecropsyRecords,
  Review,
  SuccessNecropsy,
  Summary,
} from '../../modules'
import { NecropsyRoutes } from '../types'

const Stack = createStackNavigator<NecropsyRoutes>()

export const NecropsyStack = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        gestureEnabled: false,
      }}
    >
      <Stack.Screen name='Necropsy' component={Necropsy} />
      <Stack.Screen name='ExternalPhoto' component={ExternalPhoto} />
      <Stack.Screen name='InternalPhoto' component={InternalPhoto} />
      <Stack.Screen name='GillPhoto' component={GillPhoto} />
      <Stack.Screen name='Summary' component={Summary} />
      <Stack.Screen name='NecropsyRecords' component={NecropsyRecords} />
      <Stack.Screen name='Review' component={Review} />
      <Stack.Screen name='Success' component={SuccessNecropsy} />
    </Stack.Navigator>
  )
}
